import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  contestacion:[],
};

export const mutations = {
  GET_CONTESTACION({ context }, contestacion) {
    let contestacion_array = [];
    Object.entries(contestacion).forEach(([key, val]) => contestacion_array.push(val));
    return (state.contestacion = contestacion_array);
  }
};

export const actions = {
  GET_CONTESTACION({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data);
          commit("SET_LOADING", false);
          commit("GET_CONTESTACION", response.data.data.contestacion);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_CONTESTACION({ commit }, contestacion) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(contestacion)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("SAVE_CONTESTACION", response);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SET_LEER_CONTESTACION({ commit }, data) {
    // console.log(data);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("SET_LEER_CONTESTACION", response);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_PENDIENTES_LEER({ commit }, data) {
    // console.log(data);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("SET_LEER_CONTESTACION", response);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
};

export const getters = {
  contestacion: state => state.contestacion,
};
